module.exports = __webpack_public_path__ + "static/img/wl.2f39e9a9.png";